<template>
  <div class="page flex-col">
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng47190e2cd27354a017a64ae9598b7ae32351c46eb2bd55f92244025eb58fc14c.png"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />